<template>
	<div id="systemSet">
		<el-tabs v-model.trim="activeName">
			<el-tab-pane label="系统链接" name="2">
				<el-form
					style="padding-right: 100px"
					:model="ruleForm"
					:rules="rules"
					ref="ruleForm"
					label-width="180px"
					class="demo-ruleForm"
				>
					<el-form-item>
						<h3>智慧烹饪</h3>
					</el-form-item>
					<el-form-item label="用户协议" prop="userAgreement">
						<el-input
							size="small"
							placeholder="URL"
							v-model.trim="ruleForm.userAgreement"
						></el-input>
					</el-form-item>
					<el-form-item label="隐私政策" prop="privacyPolicy">
						<el-tooltip
							class="item"
							effect="dark"
							content="用于APP端/屏端隐私声明"
							placement="top-start"
						>
							<el-input
								size="small"
								placeholder="URL"
								v-model.trim="ruleForm.privacyPolicy"
							></el-input>
						</el-tooltip>
					</el-form-item>
					<el-form-item label="APP链接">
						<img :src="'./downZHPR.png'" />
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item>
						<h3>莱克智生活</h3>
					</el-form-item>
					<el-form-item label="用户协议" prop="theSunUserAgreement">
						<el-input
							size="small"
							placeholder="URL"
							v-model.trim="ruleForm.theSunUserAgreement"
						></el-input>
					</el-form-item>
					<el-form-item label="隐私政策" prop="theSunPrivacyPolicy">
						<el-tooltip
							class="item"
							effect="dark"
							content="用于APP端/屏端隐私声明"
							placement="top-start"
						>
							<el-input
								size="small"
								placeholder="URL"
								v-model.trim="ruleForm.theSunPrivacyPolicy"
							></el-input>
						</el-tooltip>
					</el-form-item>
					<el-form-item label="APP链接">
						<img :src="'./downZSZSH.png'" />
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item label="官网链接" prop="officialLink">
						<el-input
							size="small"
							placeholder="URL"
							v-model.trim="ruleForm.officialLink"
						></el-input>
					</el-form-item>
				</el-form>
				<div class="dialog-footer">
					<el-button
						size="medium"
						type="danger"
						@click="setSub('ruleForm')"
						class="saveBtn"
						>保存</el-button
					>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeName: "2",
			ruleForm: {
				userAgreement: "", // 用户协议-》西曼帝克
				privacyPolicy: "", // 隐私协议-》西曼帝克
				appProblem: "", //APP常见问题
				officialLink: "", //官网链接
				theSunPrivacyPolicy: "", // 隐私政策-》莱克智生活
				theSunUserAgreement: "", // 用户协议-》莱克智生活
			},
			rules: {},
		};
	},
	mounted() {
		this.getSet();
	},
	methods: {
		setSub(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$http.updataSystemLink(this.ruleForm).then((res) => {
						if (res.data.success) {
							this.getSet();
						}
					});
				} else {
					return false;
				}
			});
		},
		getSet() {
			this.$http.systemLink().then((res) => {
				if (res.data.success) {
					this.ruleForm.privacyPolicy = res.data.data.privacyPolicy;
					this.ruleForm.userAgreement = res.data.data.userAgreement;
					this.ruleForm.theSunUserAgreement =
						res.data.data.theSunUserAgreement;
					this.ruleForm.theSunPrivacyPolicy =
						res.data.data.theSunPrivacyPolicy;
					this.ruleForm.officialLink = res.data.data.officialLink;
				}
			});
		},
	},
};
</script>

<style lang="less">
#systemSet {
	width: 100%;
	margin-bottom: 24px;
	float: left;
	background: #fff;
	box-sizing: border-box;
	box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.05);
	border-radius: 4px;
	.common {
		width: 100%;
		margin-bottom: 12px;
		padding: 15px 100px 15px 70px;
		box-sizing: border-box;
		border-bottom: 1px solid #d6d6d6;
		> .title {
			font-size: 16px;
			padding: 8px;
			text-indent: 40px;
			i {
				float: right;
				margin-right: -60px;
				font-size: 18px;
				cursor: pointer;
			}
		}
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #f02b54;
	}
	.el-tabs__nav-wrap {
		padding-left: 12px;
	}
	.el-tabs__active-bar {
		background-color: #f02b54;
	}
	.el-tabs__item.is-active {
		color: #2c3e50;
		font-weight: bold;
		font-size: 15px;
	}
	.dialog-footer {
		text-align: center;
		margin-bottom: 20px;
	}
	.saveBtn {
		width: 50%;
		display: block;
		margin: 0 auto;
	}
}
</style>
